import { ActivatedRoute, Router } from '@angular/router';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';

import { map, shareReplay } from 'rxjs/operators';
import { SegmentService } from 'ngx-segment-analytics';

import { SideBarService } from '@qwyk/portals/ui';
import { OnboardingService } from '@qwyk/portals/onboarding';
import { CustomerPermissions, SegmentEvent } from '@qwyk/core';
import { AuthenticationFacade } from '@qwyk/portals/authentication';

@Component({
    selector: 'qw-improved-dashboard',
    templateUrl: './improved-dashboard.component.html',
    styleUrls: ['./improved-dashboard.component.scss'],
})
export class ImprovedDashboardComponent implements OnInit, OnDestroy {

    private router = inject(Router);
    private route = inject(ActivatedRoute);
    private sidebar = inject(SideBarService);
    private segment = inject(SegmentService);
    private onboardingService = inject(OnboardingService);
    private authentication = inject(AuthenticationFacade);

    private customerPermissionsEnum = CustomerPermissions;

    queryParams$ = this.route.queryParams;
    user$ = this.authentication.user$;
    permissions$ = this.authentication.permissions$;
    view$ = this.queryParams$.pipe(
        map(p => {
            if (!p.view) {
                this.router.navigate([], { queryParams: { view: 'ops' } }).then();
                return null;
            }
            return p.view;
        })
    );
    canViewShipments$ = this.permissions$.pipe(
        map(permissions => permissions?.includes(this.customerPermissionsEnum.VIEW_SHIPMENTS)),
        shareReplay(1)
    );
    onboardingStatus$ = this.onboardingService
        .getOnboardingStatus()
        .pipe(shareReplay(1));

    ngOnInit() {
        setTimeout(() => {
            this.sidebar.background = 'bg-white';
        }, 300);
        this.segment.track(SegmentEvent.DASHBOARD_VIEW).then();
    }

    ngOnDestroy(): void {
        this.sidebar.background = 'bg-light';
    }

    get greeting(): string {
        const greetings: [number, number, string][] = [
            [0, 4, 'portal.common.greetings.good-night'],
            [5, 11, 'portal.common.greetings.good-morning'], // Store messages in an array
            [12, 17, 'portal.common.greetings.good-afternoon'],
            [18, 24, 'portal.common.greetings.good-night'],
        ];
        const hr = new Date().getHours();

        for (const greeting of greetings) {
            if (hr >= greeting[0] && hr <= greeting[1]) {
                return greeting[2] as string;
            }
        }
        return 'common.hello';
    }
}
